var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChiefEng = function SvgChiefEng(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 138.8 66.8"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".chief_eng_svg__st0{display:none}.chief_eng_svg__st1{display:inline;fill:#010101}.chief_eng_svg__st2{fill:#e2b128}.chief_eng_svg__st2,.chief_eng_svg__st3{display:inline}.chief_eng_svg__st4{fill:#e2b128}.chief_eng_svg__st5{fill:#010101}.chief_eng_svg__st6{fill:#e2b128;stroke:#e1b128;stroke-width:.75;stroke-miterlimit:10}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chief_eng_svg__chief_x5F_eng"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.4 63.3 118.9-.1c1.1 0 2.2-.4 2.7-1 0 0 8.3-13.2 8.3-13.9V19.5c0-.8-8.3-14.1-8.3-14.1-.5-.7-1.6-1.1-2.7-1.1H4.4z",
    className: "chief_eng_svg__st5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.6,
    cy: 33.8,
    r: 3.9,
    className: "chief_eng_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.357 63.235v-59h13.9v59zM45.681 63.26v-59h13.9v59zM28.006 63.284v-59h13.9v59zM10.035 63.313v-59h13.9v59z",
    className: "chief_eng_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "chief_eng_svg__XMLID_4_",
    d: "M88.1 33.9c-.6 1.4-1.6 4.2-1.4 5.4.2 1.1.3 1.9 1.8 1.9 1.4 0 3.4-2.2 3.5-3.2.1-1.3-1.4-3.1-2.2-4.1-.5.3-.2 0-.9 0-.4.1-.4.2-.8 0",
    className: "chief_eng_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "chief_eng_svg__XMLID_3_",
    d: "M82.1 31.7c.7 1 3.9 1.4 5.3 1.3v-.3c0-.9-.4-.7.3-1.2-.6-1.3-2.3-3.9-2.7-4.4-.8-.8-1.6-1.2-2.6-.1-1.1 1-1.1 3.9-.3 4.7",
    className: "chief_eng_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "chief_eng_svg__XMLID_2_",
    d: "M90.4 33.2c1.5.1 4.9-.6 5.5-.9 1-.4 1.7-1 1.1-2.4-.6-1.3-3.3-2.4-4.3-2-.6.2-2.2 2.2-2.8 3.2.7.5 1 1.6 0 1.7-.8.2.5.3.5.4",
    className: "chief_eng_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "chief_eng_svg__XMLID_1_",
    d: "M90.7 32.6c0-1-.8-1.9-1.9-1.9-1 0-1.9.8-1.9 1.9 0 1 .8 1.9 1.9 1.9 1.1-.1 1.9-.9 1.9-1.9m-1.3 0c0 .3-.2.5-.5.5s-.5-.2-.5-.5.2-.5.5-.5.5.2.5.5",
    className: "chief_eng_svg__st4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.9,
    cy: 32.6,
    r: 1,
    className: "chief_eng_svg__st4"
  }))));
};
export default SvgChiefEng;